import styled from "styled-components";

export const StyledContainer = styled("div")<{
  border?: boolean;
}>`
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin-right: auto;
  margin-left: auto;
  padding: 0 15px;
  border-top: ${(p) => (p.border ? "1px solid #444444" : "")};

  @media only screen and (max-width: 1024px) {
    max-width: calc(100% - 24px);
    padding: 0 12px;
  }

  @media only screen and (max-width: 768px) {
    max-width: calc(100% - 16px);
    padding: 0 8px;
  }

  @media only screen and (max-width: 414px) {
    max-width: 100%;
    padding: 0 6px;
  }
`;
